class SalesAreaLayerAddEditModel {
    constructor(salesAreaLayerAddEditModel?: SalesAreaLayerAddEditModel) {
        this.salesAreaLayerId = salesAreaLayerAddEditModel == undefined ? '' : salesAreaLayerAddEditModel.salesAreaLayerId == undefined ? '' : salesAreaLayerAddEditModel.salesAreaLayerId;
        this.createdUserId = salesAreaLayerAddEditModel == undefined ? '' : salesAreaLayerAddEditModel.createdUserId == undefined ? '' : salesAreaLayerAddEditModel.createdUserId;
        this.leadGroupId = salesAreaLayerAddEditModel == undefined ? '' : salesAreaLayerAddEditModel.leadGroupId == undefined ? '' : salesAreaLayerAddEditModel.leadGroupId;
        this.siteTypeId = salesAreaLayerAddEditModel == undefined ? '' : salesAreaLayerAddEditModel.siteTypeId == undefined ? '' : salesAreaLayerAddEditModel.siteTypeId;
        this.boundaryLayerId = salesAreaLayerAddEditModel == undefined ? '' : salesAreaLayerAddEditModel.boundaryLayerId == undefined ? '' : salesAreaLayerAddEditModel.boundaryLayerId;
    }
    salesAreaLayerId: string;
    createdUserId: string;
    leadGroupId: string;
    siteTypeId: string;
    boundaryLayerId: string;
}

export { SalesAreaLayerAddEditModel }